import React, { useState } from 'react';
import MessageTracker from './ChatMessageTracker';
import PulseLoader from "react-spinners/PulseLoader";

const injectCSSVariables = require('../injectStyle');

function Chat() {
  const [message, setMessage] = useState('');
  let [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [dataArray, setDataArray] = useState([
    { type: "system", message: "Hello!! How can I help you with Theming & Branding today!" }
  ]);

  const handleSend = async () => {

    if(message === "") {
        setDataArray((currentArray) => [...currentArray, buildMessageObject("I don't see any text entered. Can you help with what you are looking for", "system")]);
        return;
    }
    setDataArray((currentArray) => [...currentArray, buildMessageObject(message, "user")]);
    // let imgsrc
    // if(image) { imgsrc = preview;}
    image && setDataArray((currentArray) => [...currentArray, buildMessageObject(preview, "user", false, true)]);
    setLoading(true);
    const formData = new FormData();
    formData.append("message", message);
    if (image) {
        formData.append("image", image);
    }
    console.log("FORM DATA: ", formData);
    try {
        message && setMessage("");
        image && setImage("");
        preview && setPreview("");

      const res = await fetch('https://theming-agent-service.onrender.com/api/chat', { // Backend URL
        method: 'POST',
        body: formData,

      });
      console.log("RECEIVED RESPONSE", res);
      const response = await res.json();

      // If the response includes color mappings, inject CSS
    if (response.data && response.category !== "logoColors") {
        injectCSSVariables(response.data, response.category);
      }
      if(response.category === "logoColors") {
        setTimeout(() => {
            // setResponse(response + buildMessageTemplate(response.reply, "system"));
            setLoading(false);
            setDataArray((currentArray) => [...currentArray, buildMessageObject(response.reply, "system", response.data.colors)]);
          }, 100);
      }
      else {
        setTimeout(() => {
            // setResponse(response + buildMessageTemplate(response.reply, "system"));
            setLoading(false);
            setDataArray((currentArray) => [...currentArray, buildMessageObject(response.reply, "system")]);
          }, 100);
      }
     
    } catch (error) {
      console.error('Error:', error);
    }
  };

function buildMessageObject(message, type, colors=false, image=false) {
    console.log("BUILDING OBJECT of ", type, "-", message); 
    return {
      type,
      message,
      colors,
      image
  }
}

const fileUpload = async () => {
        let input = document.createElement('input');
        input.type = 'file';
        input.onchange = _ => {
        // you can use this method to get file and perform respective operations
                let files =   Array.from(input.files);
                setImage(files[0]);
                console.log("UPLOADED FILE", files[0]);
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreview(reader.result);
                };
                reader.readAsDataURL(files[0]);
            };
        input.click();
    };
const cancelUpload = () => {
    setImage("");
    setPreview("");
}
const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "#066afe",
  color: "#066afe",
  textAlign: "center"
};
    
  return (
    <div className='chatArea chatsContainer slds-p-around_x-small'>
        <div className='chatHeader'>
            <span className="slds-avatar slds-avatar_circle slds-avatar_small">
                <img alt="Person name" src="/icons/utility/einstein_alt_120.png" title="User avatar" />
            </span>
            <h2 className='title'>Theming Agent - NextGen <span>(PoC)</span></h2>
        </div>
        <div className='messagesArea'>
        <MessageTracker
            dataArray={dataArray}
        />
        </div>  
        <div className='controlArea'>
            <PulseLoader
              loading={loading}
              cssOverride={override}
              size={12}
              aria-label="Loading Spinner"
              data-testid="loader"
            />
            <textarea className="searchBox slds-p-around_x-small" rows={4} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Message Theming Agent" />
            <button
                className="slds-button slds-global-actions__avatar slds-global-actions__item-action uploadFileBtn"
                title="Attach file"
                onClick={fileUpload}
              >
                <span className="slds-avatar slds-avatar_circle slds-avatar_x-small">
                  <img alt="Theming Agent AI" src="/icons/utility/attach_120.png" title="Theming Agent" />
                </span>
              </button>
            <button className="slds-button slds-button_brand sendBtn" onClick={handleSend}>Send</button>
            {preview &&
            <button type="button" className="slds-button slds-truncate previewImageClose" onClick={cancelUpload}>
                 <span className="slds-icon_container slds-icon-utility-close">
                    <svg className="slds-icon slds-icon slds-icon_xx-small slds-icon-text-default" aria-hidden="true">
                      <use xlinkHref="/icons/utility-sprite/svg/symbols.svg#close"></use>
                    </svg>
                </span>
                </button>
            }
            {preview &&
                <div className="slds-avatar slds-avatar_circle slds-avatar_large previewImage">
                     <img src={preview} alt="Preview"/>
                </div>
            }
        </div>
    </div>
  );
}

export default Chat;
